import { render, staticRenderFns } from "./ContactsAddresses.vue?vue&type=template&id=34176ae8&"
import script from "./ContactsAddresses.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsAddresses.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34176ae8')) {
      api.createRecord('34176ae8', component.options)
    } else {
      api.reload('34176ae8', component.options)
    }
    module.hot.accept("./ContactsAddresses.vue?vue&type=template&id=34176ae8&", function () {
      api.rerender('34176ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsAddresses.vue"
export default component.exports